var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "bootstrapDefault mx-0",
      class: { fullSize: _vm.loading },
      attrs: { "align-center": "", "justify-center": "" },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-0 generalClass-table-padding" },
        [
          _vm.loading
            ? _c("loading-page")
            : _vm.error || !_vm.eventRules.length
            ? _c("default-page", {
                attrs: {
                  imageUrl: "/img/dynamic-src-images/event-rules.svg",
                  title: "Event Rules",
                  text: "It seems that you don't have any event rules|Click Get Started below to add an event rule",
                  buttonText: _vm.error ? "Reload" : "Get Started",
                  errorMessage: _vm.error ? _vm.errorMessage.message : "",
                },
                on: { "button-clicked": _vm.buttonClicked },
              })
            : _c(
                "div",
                [
                  _c("confirm-dialog", {
                    attrs: {
                      dialog: _vm.confirmDialog,
                      text: _vm.itemDeletionText,
                      acceptButton: "Delete",
                    },
                    on: {
                      "confirmation-event": function ($event) {
                        return _vm.deleteRule($event)
                      },
                      "mutate-confirm-dialog": _vm.mutateConfirmDialog,
                    },
                  }),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-data-table", {
                            staticClass: "main_page_table eventRulesTable",
                            staticStyle: { "border-bottom": "none" },
                            attrs: {
                              "mobile-breakpoint": 0,
                              height: _vm.windowSizeY - 100,
                              "items-per-page": _vm.itemsPerPage,
                              page: _vm.page,
                              "fixed-header": "",
                              "custom-sort": _vm.currentSortingAlgo,
                              dense: "",
                              "hide-default-header": "",
                              "hide-default-footer": "",
                              flat: "",
                              headers: _vm.headers,
                              "sort-by": "id",
                              "single-expand": "",
                              items: _vm.eventRules,
                              expanded: _vm.expanded,
                            },
                            on: {
                              "update:page": function ($event) {
                                _vm.page = $event
                              },
                              "update:expanded": function ($event) {
                                _vm.expanded = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function ({ props: { headers } }) {
                                  return [
                                    _c("thead", [
                                      _vm.$vuetify.breakpoint.mdAndUp
                                        ? _c(
                                            "tr",
                                            _vm._l(
                                              headers.filter(
                                                (el) =>
                                                  el.value !== "application"
                                              ),
                                              function (header) {
                                                return _c(
                                                  "th",
                                                  {
                                                    key: header.value,
                                                    staticClass:
                                                      "allTableHeaders",
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                          justify: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              height: "100%",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                class:
                                                                  header.value ===
                                                                    "expand" ||
                                                                  header.value ===
                                                                    "activate"
                                                                    ? "pl-0"
                                                                    : "pl-3",
                                                                style:
                                                                  header.value ===
                                                                    "expand" ||
                                                                  header.value ===
                                                                    "activate"
                                                                    ? "justify-content: center;"
                                                                    : "",
                                                              },
                                                              [
                                                                _c("v-hover", {
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function ({
                                                                            hover,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "my-0 fullHeight",
                                                                                  class:
                                                                                    header.value ===
                                                                                      "expand" ||
                                                                                    header.value ===
                                                                                      "activate"
                                                                                      ? "text-center"
                                                                                      : "allTableHeadersHover",
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.currentSortingAlgo =
                                                                                          _vm.getNewSortingAlgo(
                                                                                            header
                                                                                          )
                                                                                        _vm.selectedHeader =
                                                                                          header.value
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        header.text
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      directives:
                                                                                        [
                                                                                          {
                                                                                            name: "show",
                                                                                            rawName:
                                                                                              "v-show",
                                                                                            value:
                                                                                              header.value !==
                                                                                                "expand" &&
                                                                                              header.value !==
                                                                                                "activate",
                                                                                            expression:
                                                                                              "\n                                  header.value !== 'expand' &&\n                                    header.value !== 'activate'\n                                ",
                                                                                          },
                                                                                        ],
                                                                                      staticStyle:
                                                                                        {
                                                                                          "font-size":
                                                                                            "12px",
                                                                                          "margin-left":
                                                                                            "-3px",
                                                                                        },
                                                                                      style:
                                                                                        !hover &&
                                                                                        _vm.selectedHeader !==
                                                                                          header.value
                                                                                          ? "opacity: 0.2;"
                                                                                          : "opacity: 1;",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.getSortingIcon(
                                                                                            header.currentSortAlg
                                                                                          )
                                                                                        ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm.$vuetify.breakpoint.width > 525
                                        ? _c(
                                            "tr",
                                            { staticClass: "force-width-100" },
                                            _vm._l(4, function (number, index) {
                                              return _c(
                                                "th",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "allTableHeaders",
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      attrs: {
                                                        align: "center",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            height: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              class:
                                                                headers[index]
                                                                  .value ===
                                                                "expand"
                                                                  ? "pl-0"
                                                                  : "pl-3",
                                                              style:
                                                                headers[index]
                                                                  .value ===
                                                                "expand"
                                                                  ? "justify-content: center;"
                                                                  : "",
                                                            },
                                                            [
                                                              _c("v-hover", {
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          hover,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "my-0 fullHeight",
                                                                                class:
                                                                                  headers[
                                                                                    index
                                                                                  ]
                                                                                    .value ===
                                                                                    "expand" ||
                                                                                  headers[
                                                                                    index
                                                                                  ]
                                                                                    .value ===
                                                                                    "activate"
                                                                                    ? "text-center"
                                                                                    : "allTableHeadersHover",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.currentSortingAlgo =
                                                                                        _vm.getNewSortingAlgo(
                                                                                          headers[
                                                                                            index
                                                                                          ]
                                                                                        )
                                                                                      _vm.selectedHeader =
                                                                                        headers[
                                                                                          index
                                                                                        ].value
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      headers[
                                                                                        index
                                                                                      ]
                                                                                        .text
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    directives:
                                                                                      [
                                                                                        {
                                                                                          name: "show",
                                                                                          rawName:
                                                                                            "v-show",
                                                                                          value:
                                                                                            headers[
                                                                                              index
                                                                                            ]
                                                                                              .value !==
                                                                                              "expand" &&
                                                                                            headers[
                                                                                              index
                                                                                            ]
                                                                                              .value !==
                                                                                              "activate",
                                                                                          expression:
                                                                                            "\n                                  headers[index].value !== 'expand' &&\n                                    headers[index].value !== 'activate'\n                                ",
                                                                                        },
                                                                                      ],
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-size":
                                                                                          "12px",
                                                                                        "margin-left":
                                                                                          "-3px",
                                                                                      },
                                                                                    style:
                                                                                      !hover &&
                                                                                      _vm.selectedHeader !==
                                                                                        headers[
                                                                                          index
                                                                                        ]
                                                                                          .value
                                                                                        ? "opacity: 0.2;"
                                                                                        : "opacity: 1;",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm.getSortingIcon(
                                                                                            headers[
                                                                                              index
                                                                                            ]
                                                                                              .currentSortAlg
                                                                                          )
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          )
                                        : _c(
                                            "tr",
                                            { staticClass: "force-width-100" },
                                            [
                                              _c(
                                                "th",
                                                {
                                                  staticClass:
                                                    "allTableHeaders",
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      attrs: {
                                                        align: "center",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            height: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              class:
                                                                headers[0]
                                                                  .value ===
                                                                "expand"
                                                                  ? "pl-0"
                                                                  : "pl-3",
                                                              attrs: {
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c("v-hover", {
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          hover,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "my-0 fullHeight",
                                                                                class:
                                                                                  headers[0]
                                                                                    .value ===
                                                                                    "expand" ||
                                                                                  headers[0]
                                                                                    .value ===
                                                                                    "activate"
                                                                                    ? "text-center"
                                                                                    : "allTableHeadersHover",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.currentSortingAlgo =
                                                                                        _vm.getNewSortingAlgo(
                                                                                          headers[0]
                                                                                        )
                                                                                      _vm.selectedHeader =
                                                                                        headers[0].value
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      headers[1]
                                                                                        .text
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                                _c(
                                                                                  "v-icon",
                                                                                  {
                                                                                    directives:
                                                                                      [
                                                                                        {
                                                                                          name: "show",
                                                                                          rawName:
                                                                                            "v-show",
                                                                                          value:
                                                                                            headers[0]
                                                                                              .value !==
                                                                                              "expand" &&
                                                                                            headers[0]
                                                                                              .value !==
                                                                                              "activate",
                                                                                          expression:
                                                                                            "\n                                  headers[0].value !== 'expand' &&\n                                    headers[0].value !== 'activate'\n                                ",
                                                                                        },
                                                                                      ],
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-size":
                                                                                          "12px",
                                                                                        "margin-left":
                                                                                          "-3px",
                                                                                      },
                                                                                    style:
                                                                                      !hover &&
                                                                                      _vm.selectedHeader !==
                                                                                        headers[0]
                                                                                          .value
                                                                                        ? "opacity: 0.2;"
                                                                                        : "opacity: 1;",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm.getSortingIcon(
                                                                                            headers[0]
                                                                                              .currentSortAlg
                                                                                          )
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function ({ item, index }) {
                                  return [
                                    _vm.$vuetify.breakpoint.mdAndUp
                                      ? _c(
                                          "tr",
                                          {
                                            class: _vm.$vuetify.theme.dark
                                              ? "backgroundBlack"
                                              : "backgroundWhite",
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "char-lim" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.name) +
                                                    " (" +
                                                    _vm._s(item.application) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                            _c("td", [
                                              _vm._v(_vm._s(item.priority)),
                                            ]),
                                            _c(
                                              "td",
                                              { staticClass: "char-lim" },
                                              [_vm._v(_vm._s(item.namespace))]
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "char-lim" },
                                              [_vm._v(_vm._s(item.description))]
                                            ),
                                            _c(
                                              "td",
                                              {
                                                staticClass: "px-0",
                                                staticStyle: {
                                                  "text-align":
                                                    "center !important",
                                                },
                                              },
                                              [
                                                _c("v-switch", {
                                                  staticClass:
                                                    "mt-0 rule-switch",
                                                  attrs: { color: "primary" },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.switchRule(
                                                        item.enabled,
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.enabled,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "enabled",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.enabled",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      id: `edit-eventrule${index}`,
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.editRule(item)
                                                        _vm.expandRow(item)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon-edit-21x21",
                                                        staticStyle: {
                                                          "font-size": "28px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "path1 letterSpacing0",
                                                        }),
                                                        _c("span", {
                                                          staticClass: "path2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mt-3 ml-1",
                                                    attrs: {
                                                      activator: `#edit-eventrule${index}`,
                                                      bottom: "",
                                                    },
                                                  },
                                                  [_c("span", [_vm._v("Edit")])]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      id: `delete-eventrule${index}`,
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmationDialog(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon-delete-21x21",
                                                        staticStyle: {
                                                          "font-size": "28px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "path1 letterSpacing0",
                                                        }),
                                                        _c("span", {
                                                          staticClass: "path2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mt-3 ml-1",
                                                    attrs: {
                                                      activator: `#delete-eventrule${index}`,
                                                      bottom: "",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Delete"),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm.$vuetify.breakpoint.width > 525
                                      ? _c(
                                          "tr",
                                          {
                                            staticClass:
                                              "rowClick force-width-100",
                                            attrs: {
                                              id: _vm.$vuetify.theme.dark
                                                ? "dataTableRow_dark"
                                                : "dataTableRow_light",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.expandRow(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              { staticClass: "char-lim" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    class: _vm.expanded.some(
                                                      (el) => el.id === item.id
                                                    )
                                                      ? "red--text pr-1"
                                                      : "primary--text pr-1",
                                                    staticStyle: {
                                                      "font-size": "16px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.expanded.some(
                                                            (el) =>
                                                              el.id === item.id
                                                          )
                                                            ? "fas fa-times-circle"
                                                            : "fas fa-chevron-circle-down"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.name) +
                                                    " (" +
                                                    _vm._s(item.application) +
                                                    ") "
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              { staticClass: "table_Row" },
                                              [_vm._v(_vm._s(item.application))]
                                            ),
                                            _c("td", [
                                              _vm._v(_vm._s(item.priority)),
                                            ]),
                                            _c(
                                              "td",
                                              { staticClass: "char-lim" },
                                              [_vm._v(_vm._s(item.namespace))]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "tr",
                                          {
                                            staticClass:
                                              "rowClick force-width-100",
                                            staticStyle: { height: "32px" },
                                            attrs: {
                                              id: _vm.$vuetify.theme.dark
                                                ? "dataTableRow_dark"
                                                : "dataTableRow_light",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.expandRow(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "td",
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    attrs: {
                                                      justify: "center",
                                                      align: "center",
                                                    },
                                                  },
                                                  [
                                                    _c("v-col", {
                                                      staticClass: "pa-0",
                                                      attrs: { cols: "4" },
                                                    }),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "pa-0",
                                                        attrs: { cols: "8" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "char-lim ml-4",
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                class:
                                                                  _vm.expanded.some(
                                                                    (el) =>
                                                                      el.id ===
                                                                      item.id
                                                                  )
                                                                    ? "red--text pr-1"
                                                                    : "primary--text pr-1",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "16px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.expanded.some(
                                                                        (el) =>
                                                                          el.id ===
                                                                          item.id
                                                                      )
                                                                        ? "fas fa-times-circle"
                                                                        : "fas fa-chevron-circle-down"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.name
                                                                ) +
                                                                " (" +
                                                                _vm._s(
                                                                  item.application
                                                                ) +
                                                                ") "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                  ]
                                },
                              },
                              {
                                key: "expanded-item",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "td",
                                      {
                                        attrs: {
                                          colspan: _vm.countOfHeadersShowing,
                                        },
                                      },
                                      [
                                        _vm.$vuetify.breakpoint.smAndDown
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "expandBackground",
                                              },
                                              [
                                                _vm.$vuetify.breakpoint.width <=
                                                525
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "expandRowClass_Border mx-0",
                                                        staticStyle: {
                                                          height: "32px",
                                                        },
                                                        attrs: {
                                                          justify:
                                                            "space-around",
                                                        },
                                                      },
                                                      [
                                                        _vm.$vuetify.breakpoint
                                                          .width <= 525
                                                          ? _c("v-col", {
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "py-1 pr-0",
                                                            staticStyle: {
                                                              "font-weight":
                                                                "600",
                                                              "font-size":
                                                                "14px",
                                                            },
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "pl-3",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Priority"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "py-1 px-0 text-center",
                                                            staticStyle: {
                                                              "font-size":
                                                                "14px",
                                                            },
                                                            attrs: {
                                                              cols: "8",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item["priority"]
                                                              ) + " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.$vuetify.breakpoint.width <=
                                                525
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "expandRowClass_Border mx-0",
                                                        staticStyle: {
                                                          height: "32px",
                                                        },
                                                        attrs: {
                                                          justify:
                                                            "space-around",
                                                        },
                                                      },
                                                      [
                                                        _vm.$vuetify.breakpoint
                                                          .width <= 525
                                                          ? _c("v-col", {
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "py-1 pr-0",
                                                            staticStyle: {
                                                              "font-weight":
                                                                "600",
                                                              "font-size":
                                                                "14px",
                                                            },
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "pl-3",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Namespace"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "py-1 text-center",
                                                            staticStyle: {
                                                              "font-size":
                                                                "14px",
                                                            },
                                                            attrs: {
                                                              cols: "8",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item[
                                                                  "namespace"
                                                                ]
                                                              ) + " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass:
                                                      "expandRowClass_Border mx-0",
                                                    staticStyle: {
                                                      height: "32px",
                                                    },
                                                    attrs: {
                                                      justify: "space-around",
                                                    },
                                                  },
                                                  [
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 525
                                                      ? _c("v-col", {
                                                          attrs: { cols: "1" },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "py-1 pr-0",
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                          "font-size": "14px",
                                                        },
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "pl-3",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Description"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "py-1 text-center",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                        attrs: { cols: "8" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item["description"]
                                                          ) + " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass:
                                                      "expandRowClass_Border mx-0",
                                                    staticStyle: {
                                                      "max-height": "32px",
                                                    },
                                                    attrs: {
                                                      justify: "space-around",
                                                    },
                                                  },
                                                  [
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 525
                                                      ? _c("v-col", {
                                                          attrs: { cols: "1" },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "py-1",
                                                        staticStyle: {
                                                          "max-height": "32px",
                                                          "font-weight": "600",
                                                          "font-size": "14px",
                                                        },
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "pl-3",
                                                          },
                                                          [_vm._v("Activate")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "py-0",
                                                        staticStyle: {
                                                          "font-size": "14px",
                                                        },
                                                        attrs: { cols: "8" },
                                                      },
                                                      [
                                                        _c("v-switch", {
                                                          staticClass: "mt-0",
                                                          staticStyle: {
                                                            "max-height":
                                                              "32px",
                                                            width: "100%",
                                                            "max-width": "40px",
                                                            "margin-left":
                                                              "auto",
                                                            "margin-right":
                                                              "auto",
                                                            "text-align":
                                                              "center",
                                                          },
                                                          attrs: {
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              item.enabled
                                                                ? _vm.switchRule(
                                                                    true,
                                                                    item.id,
                                                                    item.name,
                                                                    item.namespace
                                                                  )
                                                                : _vm.switchRule(
                                                                    false,
                                                                    item.id,
                                                                    item.name,
                                                                    item.namespace
                                                                  )
                                                            },
                                                          },
                                                          model: {
                                                            value: item.enabled,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "enabled",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.enabled",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass:
                                                      "actions_header mx-0",
                                                    attrs: {
                                                      justify: "space-around",
                                                    },
                                                  },
                                                  [
                                                    _vm.$vuetify.breakpoint
                                                      .width <= 525
                                                      ? _c("v-col", {
                                                          attrs: { cols: "1" },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "py-1",
                                                        staticStyle: {
                                                          "font-weight": "600",
                                                          "font-size": "14px",
                                                        },
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "pl-3 mb-0",
                                                          },
                                                          [_vm._v("Actions")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 text-center",
                                                        attrs: { cols: "8" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              height: "32",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.editRule(
                                                                  item
                                                                )
                                                                _vm.showQueryBuilder =
                                                                  !_vm.showQueryBuilder
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon-edit-21x21",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "28px",
                                                                },
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path1 letterSpacing0",
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path2",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              height: "32",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmationDialog(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon-delete-21x21",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "28px",
                                                                },
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path1 letterSpacing0",
                                                                }),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "path2",
                                                                }),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.showQueryBuilder ||
                                        _vm.$vuetify.breakpoint.mdAndUp
                                          ? _c(
                                              "div",
                                              {
                                                class: _vm.$vuetify.theme.dark
                                                  ? "noHoverBackground-dark"
                                                  : "",
                                                attrs: { flat: "" },
                                              },
                                              [
                                                _c(
                                                  "v-card",
                                                  { attrs: { flat: "" } },
                                                  [
                                                    _vm.$vuetify.breakpoint
                                                      .smAndUp
                                                      ? _c(
                                                          "v-row",
                                                          {
                                                            staticClass: "mx-0",
                                                            class: _vm.$vuetify
                                                              .theme.dark
                                                              ? "queryBuilder--dark queryBackground_dark"
                                                              : "queryBuilder--light queryBackground_light",
                                                            attrs: {
                                                              justify:
                                                                "space-around",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "vue-query-builder",
                                                                  {
                                                                    attrs: {
                                                                      maxDepth: 5,
                                                                      rules:
                                                                        _vm.rules,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.query,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.query =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "query",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "6",
                                                                  md: "5",
                                                                  lg: "4",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-form",
                                                                  {
                                                                    ref: "rulesForm",
                                                                    model: {
                                                                      value:
                                                                        _vm.validExpand,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.validExpand =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "validExpand",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule description",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharDescription,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 200 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .description,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "description",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.description",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0",
                                                                        attrs: {
                                                                          autofocus:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule name",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .required,
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharName,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 50 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .name,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "name",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.name",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0 textFieldHeight",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule namespace",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharName,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 50 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .namespace,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "namespace",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.namespace",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "input-wrapper2",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Subscription Groups",
                                                                          "full-width":
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "subscription-groups",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "event-rule":
                                                                                  _vm.newEventRuleObject,
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-row",
                                                                      {
                                                                        attrs: {
                                                                          justify:
                                                                            "end",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                text: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.expanded =
                                                                                    []
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Cancel"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                disabled:
                                                                                  !_vm.validExpand,
                                                                                color:
                                                                                  "primary",
                                                                                text: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.saveHandler()
                                                                                  _vm.expanded =
                                                                                    []
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Save "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-row",
                                                          {
                                                            staticClass: "mx-0",
                                                            class: _vm.$vuetify
                                                              .theme.dark
                                                              ? "queryBuilder--dark queryBackground_dark"
                                                              : "queryBuilder--light queryBackground_light",
                                                            attrs: {
                                                              justify:
                                                                "space-around",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pb-0",
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "6",
                                                                  md: "5",
                                                                  lg: "4",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-form",
                                                                  {
                                                                    ref: "rulesForm",
                                                                    model: {
                                                                      value:
                                                                        _vm.validExpand,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.validExpand =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "validExpand",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule description",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharDescription,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 200 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .description,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "description",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.description",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0",
                                                                        attrs: {
                                                                          autofocus:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule name",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .required,
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharName,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 50 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .name,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "name",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.name",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 ma-0 textFieldHeight",
                                                                        attrs: {
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          label:
                                                                            "Rule namespace",
                                                                          rules:
                                                                            [
                                                                              _vm
                                                                                .validationRules
                                                                                .maxCharName,
                                                                            ],
                                                                          counter:
                                                                            "",
                                                                          hint: "Max 50 Character",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .newEventRuleObject
                                                                              .namespace,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.newEventRuleObject,
                                                                                "namespace",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "newEventRuleObject.namespace",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-row",
                                                                      {
                                                                        attrs: {
                                                                          justify:
                                                                            "end",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                text: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.expanded =
                                                                                    []
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Cancel"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                disabled:
                                                                                  !_vm.validExpand,
                                                                                color:
                                                                                  "primary",
                                                                                text: "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.saveHandler()
                                                                                  _vm.expanded =
                                                                                    []
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Save "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                attrs: {
                                                                  cols: "12",
                                                                  sm: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "vue-query-builder",
                                                                  {
                                                                    attrs: {
                                                                      maxDepth: 5,
                                                                      rules:
                                                                        _vm.rules,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .query
                                                                          .children,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.query,
                                                                            "children",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "query.children",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-alert",
                                      {
                                        attrs: {
                                          value: true,
                                          color: "primary",
                                          icon: "warning",
                                          outlined: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " It seems that you don't have any rules. Click at "
                                        ),
                                        _c("v-icon", [_vm._v("add")]),
                                        _vm._v(" to add a rule! "),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center custom-table-footer" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    justify: "space-between",
                                    "justify-sm": "end",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ml-2 pagination-item-1" },
                                    [
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c("div", { staticClass: "mr-6" }, [
                                            _vm._v(" Rows per page: "),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "footer-items-wrapper",
                                          class: {
                                            "mr-1":
                                              _vm.$vuetify.breakpoint.smAndUp,
                                          },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass:
                                              "footer-items-per-page mt-0",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              "menu-props": {
                                                top: true,
                                                offsetY: true,
                                              },
                                              items: [10, 25, 50, 100],
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.paginationChangeHandler(
                                                  1
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mb-0 char-lim-tabs page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v("All"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v(" All "),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(item) +
                                                                  " "
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                            model: {
                                              value: _vm.itemsPerPage,
                                              callback: function ($$v) {
                                                _vm.itemsPerPage = $$v
                                              },
                                              expression: "itemsPerPage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("v-pagination", {
                                    staticClass: "pagination",
                                    attrs: {
                                      length: _vm.totalPages,
                                      "total-visible": _vm.$vuetify.breakpoint
                                        .xsOnly
                                        ? 5
                                        : 7,
                                      circle: "",
                                    },
                                    on: { input: _vm.paginationChangeHandler },
                                    model: {
                                      value: _vm.page,
                                      callback: function ($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          !_vm.loading && !_vm.error && _vm.eventRules.length
            ? _c(
                "v-btn",
                {
                  style: { bottom: "70px" },
                  attrs: {
                    fab: "",
                    bottom: "",
                    right: "",
                    color: _vm.$vuetify.theme.dark ? "#685AA1" : "primary",
                    dark: "",
                    fixed: "",
                  },
                  on: { click: _vm.addEventRule },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: {
                transition: "scroll-x-transition",
                "overlay-color": "grey darken-2",
                "max-width": "750px",
                persistent: "",
              },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { color: "accent" } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: {
                        "background-color": "#47BD96",
                        color: "white",
                      },
                    },
                    [_vm._v(" New Rule ")]
                  ),
                  _c(
                    "v-container",
                    { staticClass: "pa-4 pb-0", attrs: { "grid-list-sm": "" } },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "confRulesForm",
                          staticClass: "pt-4",
                          attrs: { "lazy-validation": false },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      autofocus: "",
                                      dense: "",
                                      outlined: "",
                                      label: "Rule name",
                                      rules: [
                                        _vm.validationRules.required,
                                        _vm.validationRules.maxCharName,
                                      ],
                                      counter: "",
                                      hint: "Max 50 Character",
                                    },
                                    model: {
                                      value:
                                        _vm.newEventRuleObjectForDialog.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEventRuleObjectForDialog,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "newEventRuleObjectForDialog.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Rule description",
                                      rules: [
                                        _vm.validationRules.maxCharDescription,
                                      ],
                                      counter: "",
                                      hint: "Max 200 Character",
                                    },
                                    model: {
                                      value:
                                        _vm.newEventRuleObjectForDialog
                                          .description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEventRuleObjectForDialog,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "newEventRuleObjectForDialog.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Rule namespace",
                                      rules: [_vm.validationRules.maxCharName],
                                      counter: "",
                                      hint: "Max 50 Character",
                                    },
                                    model: {
                                      value:
                                        _vm.newEventRuleObjectForDialog
                                          .namespace,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEventRuleObjectForDialog,
                                          "namespace",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "newEventRuleObjectForDialog.namespace",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "pt-0" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.$refs.confRulesForm.validate()
                                ? _vm.saveHandler()
                                : false
                            },
                          },
                        },
                        [_vm._v("Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }